module.exports = __webpack_public_path__ + "static/img/pha.8dc37a5d.png";